const defaultState = '';
const home = (state = defaultState, action) => {
  switch (action.type) {
    case 'GET_OVERVIEW_SUCCESS':{
      return action.overview
    }
    default:
      return state;
  }
};

export default home
